'use client';

import { useState, useEffect } from 'react';

interface Section {
  id: string;
  label: string;
}

interface ScrollProgressIndicatorProps {
  sections: Section[];
}

const ScrollProgressIndicator = ({ sections }: ScrollProgressIndicatorProps) => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const calculateProgress = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY;
      
      const totalScrollableHeight = documentHeight - windowHeight;
      const progress = (scrollTop / totalScrollableHeight) * 100;
      
      setScrollProgress(Math.min(100, Math.max(0, progress)));
    };

    const handleScroll = () => {
      requestAnimationFrame(calculateProgress);
    };

    window.addEventListener('scroll', handleScroll);
    calculateProgress();

    return () => window.removeEventListener('scroll', handleScroll);
  }, [sections]);

  return (
    <div data-component-id="src/components/common/ScrollProgressIndicator.tsx:40:4" data-component-path="src/components/common/ScrollProgressIndicator.tsx" data-component-line="40" data-component-end-line="46" data-component-file="ScrollProgressIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22fixed%20top-20%20left-0%20right-0%20z-150%20h-1%20%20bg-black%22%7D" className="fixed top-20 left-0 right-0 z-150 h-1  bg-black">     {/* bg-surface */}

      <div data-component-id="src/components/common/ScrollProgressIndicator.tsx:42:6" data-component-path="src/components/common/ScrollProgressIndicator.tsx" data-component-line="42" data-component-end-line="45" data-component-file="ScrollProgressIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-full%20bg-gradient-to-r%20from-primary%20via-secondary%20to-accent%20transition-all%20duration-300%20ease-out%22%7D"
        className="h-full bg-gradient-to-r from-primary via-secondary to-accent transition-all duration-300 ease-out"
        style={{ width: `${scrollProgress}%` }}
      />
    </div>
  );
};

export default ScrollProgressIndicator;